import type { MaybeRefOrGetter } from 'vue';
import type { UsercentricsServiceKey } from '@/utils/usercentricsServices';
import {
    acceptUsercentricsConsent,
    onConsentUpdated,
    refreshUsercentricsConsentCache,
    useUsercentricsConsentItem
} from '@/utils/manageUsercentricsConsent';
import log from '~/utils/log';

export const useUsercentricsConsent = (serviceKey: MaybeRefOrGetter<UsercentricsServiceKey>) => {
    const consent = useUsercentricsConsentItem(serviceKey);
    const hasConsent = computed(() => consent.value === true);
    let unsubscribeConsentUpdates: (() => void) | null = null;

    const refreshConsent = async () => {
        await refreshUsercentricsConsentCache();

        return hasConsent.value;
    };

    const acceptConsent = async () => {
        await acceptUsercentricsConsent(toValue(serviceKey)).catch((error) => {
            log.warn('Failed to accept Usercentrics consent', error);
        });

        return hasConsent.value;
    };

    onMounted(() => {
        refreshUsercentricsConsentCache().catch((error) => {
            log.warn('Failed to refresh Usercentrics consent state', error);
        });

        unsubscribeConsentUpdates = onConsentUpdated();
    });

    onBeforeUnmount(() => {
        unsubscribeConsentUpdates?.();
    });

    return {
        acceptConsent,
        hasConsent,
        refreshConsent
    };
};
